<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" title="Part I: Critique and Clarification">
<p class="pn"><span class="right_1" epub:type="pagebreak" id="page_15" title="15"><a href="#/text/00a_Yob_and_Jorgensen_fm_prod0d#part1">PART I</a></span></p>
<p class="pt"><a href="#/text/00a_Yob_and_Jorgensen_fm_prod0d#part1">CRITIQUE AND CLARIFICATION</a><span class="right_1" epub:type="pagebreak" id="page_16" title="16"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?cd82a836